<template>
  <div class="modal fade bd-example-modal-lg" :id="'materialProperty' + attr.id" tabindex="-1" role="dialog"
    aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" :id="'materialProperty' + attr.id + 'Title'">
            ویژگی های متریال
          </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="بستن">
            <i class="ti-close"></i>
          </button>
        </div>
        <form @submit.prevent="onSubmit(attr.id, attrIndex, name, 'materialProperty' + attr.id)">
          <!-- <p v-for="(property, key, index) in properties" :key="index">
            {{key}}
          </p> -->
          <div class="modal-body">
            <div v-for="(property, key, index) in properties" :key="index" >
              <div class="form-group row" v-if="property.type!='multiple'">
                <label class="col-sm-4 col-form-label">{{property.name}}</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control text-left" :name="key" dir="rtl" v-model="form[key]" />
                </div>
              </div>
              <div class="form-group row" v-else>
                <label class="col-sm-4 col-form-label">{{property.name}}</label>
                <div class="accordion accordion-primary custom-accordion col-sm-8 mp-2">
                  <div class="accordion-row">
                    <a href="#" class="accordion-header">
                      <span>{{new Intl.NumberFormat().format(form[property.key])}}</span>
                      <i class="accordion-status-icon close fa fa-plus"></i>
                      <i class="accordion-status-icon open fa fa-close"></i>
                    </a>
                    <div class="accordion-body">
                      <div class="table-responsive">
                        <table class="table">
                          <thead>
                            <tr>
                              <th>ردیف</th>
                              <th>{{property.name}}</th>
                              <th>تاریخ ثبت</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(object, index) in form[key]" :key="index">
                              <td>{{index+1}}</td>
                              <td>
                                <p dir="ltr">
                                 {{new Intl.NumberFormat().format(object.value)}}
                                </p>
                              </td>
                              <td>{{object.date}}</td>
                            </tr>
                            <tr v-if="!add">
                              <td></td>
                              <td><input type="text" class="form-control text-left" dir="ltr"
                                  v-model="new_value.value" /></td>
                              <td></td>
                            </tr>
                          </tbody>
                        </table>
                        <button type="button" class="btn btn-outline-warning btn-block" @click="addValue"
                          v-if="add">افزودن</button>
                        <button type="button" class="btn btn-outline-info btn-block" @click="submit(key, property.key)"
                          v-else>ثبت</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              بستن
            </button>
            <button type="submit" class="btn btn-primary">
              ذخیره
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['attr', 'properties', 'attrIndex', 'name', 'property_default'],
  data () {
    return {
      form: null,
      add: true,
      myObject: [{
        id: 1,
        value: 525,
        date: '1399/2/5'
      },
      {
        id: 1,
        value: 25,
        date: '1399/2/5'
      }
      ],
      new_value: {
        value: null
      }
    }
  },
  created () {
    this.form = this.property_default
    if (this.attr.detail) {
      this.form = this.attr.detail
    }
    // console.log(this.form.)
  },
  methods: {
    onSubmit (attributeID, attrIndex, name, modal) {
      this.form.total_price = this.form.area_number * this.form.unit_price
      this.form.total_wage_installer = this.form.executive_length * this.form.wage_installer
      this.$send.submit('post', 'api/project/' + attributeID + '/change/detail', this.form)
        .then(response => {
          this.attr = response
          window.$('#' + modal).modal('hide')
        })
    },
    addValue () {
      this.add = false
    },
    submit (key, property) {
      this.$send.submit('post', 'api/attribute/' + key + '/' + this.attr.id, { value: this.new_value.value })
        .then(response => {
          this.form[property] = parseInt(this.new_value.value) + parseInt(this.form[property])
          this.new_value.value = null
          this.add = true
          this.form[key].push(response)
        })
    }
    // submit_payment (key) {
    //   this.$api.post('/api/attribute/payment' + this.attr.id, {
    //     value: this.payment_new_value.value
    //   }).then(response => {
    //     // console.log(response)
    //     this.payment_new_value.value = null
    //     this.add = true
    //     this.form.payments.push(response.data)
    //   })
    // }
  }

}

</script>

<style>

</style>
